import React from 'react'

interface Props {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

/** Search is the one view control that stays visible on every list page. */
export const PageBarSearch = ({ value, onChange, placeholder = 'Search' }: Props) => (
  // A floor as well as a ceiling: allowed to shrink to nothing, the field
  // collapses until its own placeholder is clipped instead of wrapping to its
  // own row.
  <div className="relative min-w-0 flex-1" style={{ minWidth: 180, maxWidth: 320 }}>
    <i
      className="fad fa-search pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs text-mm-neutral-1-400"
      aria-hidden
    />
    <input
      type="search"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
      className="h-9 w-full rounded-lg border border-mm-neutral-1-300 bg-white pl-8 pr-3 text-sm text-mm-neutral-1-900 placeholder-mm-neutral-1-400 focus:border-mm-primary-500 focus:outline-none"
    />
  </div>
)
